import React from 'react'

import { Icon } from 'components/UI'

import { searchDebounceDelay } from 'settings'

import { useUncontrolled } from 'hooks/useUncontrolled'

import { debounce, Input, SxProps } from '@mui/material'

interface SearchProps {
  value?: string
  defaultValue?: string
  placeholder?: string
  name?: string
  onChange: (value: string) => void
  fullWidth?: boolean
  sx?: SxProps
}

export const Search = ({
  value,
  defaultValue,
  onChange,
  fullWidth = true,
  placeholder = 'Search',
  name = 'search',
  sx,
}: SearchProps) => {
  const ref = React.useRef<HTMLInputElement>()

  const [internalValue, internalOnChange] = useUncontrolled({
    value,
    defaultValue,
    finalValue: '',
    onChange: debounce(onChange, searchDebounceDelay),
  })

  return (
    <Input
      inputRef={ref}
      value={internalValue}
      name={name}
      defaultValue={defaultValue}
      placeholder={placeholder}
      sx={sx}
      endAdornment={<Icon name="search" />}
      onChange={e => internalOnChange(e.target.value)}
      fullWidth={fullWidth}
    />
  )
}
